import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { AuthenticationResponse } from "../../Interfaces/AuthenticationResponse";
import { BCAppUser } from "../../Interfaces/BCAppUser";
import { RootState } from "../store"

// Define a type for the slice state
interface UserState {
    resourceNo: string | null,
    resourceName: string | null,
    token: string | null,
    tokenExpiration: string | null,
}

// Define the initial state using that type
var user: AuthenticationResponse = JSON.parse(localStorage.getItem("deloof.service.user")!!);
const emptyState: UserState = {
    resourceNo: null,
    resourceName: null,
    token: null,
    tokenExpiration: null,
}

const initialState: UserState = user ? {
    resourceNo: user.resourceNo,
    resourceName: user.resourceName,
    token: user.token,
    tokenExpiration: null,
} : emptyState

export const userSlice = createSlice({
    name: 'user',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState: initialState
    ,
    reducers: {
        setToken: (state, action: PayloadAction<UserState>) => {
            return action.payload;
        },
        actionUnauthorized: (state) => {
            localStorage.setItem("deloof.service.user", JSON.stringify(emptyState));
            state.token = null;
            state.resourceNo = null;
        },
        actionLogOut: (state) => {
            localStorage.setItem("deloof.service.user", JSON.stringify(emptyState));
            return emptyState;
        }
    },
})

export const { setToken, actionLogOut, actionUnauthorized } = userSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectUser = (state: RootState) => state.user

export default userSlice.reducer